import React, { useMemo } from 'react';
import {
    Divider,
    Footer,
    Line,
    PriceTag,
    SubmitDescription,
    SubmitDescriptionWrapper,
    Wrapper,
} from './form-purchase.styles';
import { Typography } from '@shared/ui/typography/typography';
import { RefundMoney } from '@vtbhome/juicyfront/indexIcon';
import { Button, Link } from '@vtbhome/juicyfront';
import { FormPurchaseProps } from './types';
import { useCurrentUserSelector } from '@entities/current-user/model/selectors';
import { UserRoles } from '@shared/model/user';
import { useCurrentOrganizationPreviewSharedQuery } from '@entities/organization/libs/hooks/use-current-organization-preview-shared-query/use-current-organization-preview-shared-query';
import { useCreateRequestMutation } from '@entities/request/api/request-api';
import { CACHE_KEY_EMPLOYEE_CREATE_REQUEST } from '@entities/request/config/api-constants';
import { InputCount } from '@shared/ui/input-count/input-count';
import { useCreateRequestBeforePurchaseMutation } from '../../api/request-api';
import { CACHE_KEY_MANAGER_CREATE_REQUEST_BEFORE_PURCHASE } from '../../config/api-constants';
import { useRequestsListSharedQuery } from '@entities/request/libs/hooks/use-request-list-shared-query/use-request-list-shared-query';
import { useDispatch } from 'react-redux';
import { setIsShowCreateFeedbackRequest } from '@entities/feedback/model/slice';
import { buyProductText } from '@shared/lib/utils/buy-product-text/buy-product-text';
import { ProductTypeCode } from '@shared/model/product';
import { productPrice } from '@shared/lib/utils/product-price/product-price';

export const FormPurchase: React.FC<FormPurchaseProps> = ({
    product,
    productCounter,
    ownRequestsParameters,
    setProductCounter,
    // onShowBecomeManager,
    // onCreateRequestEmployee,
    onBuyProductManager,
    onCreateOrderEmployee,
}) => {
    const dispatch = useDispatch();
    const user = useCurrentUserSelector();
    const [, currentOrganization] = useCurrentOrganizationPreviewSharedQuery(user?.company?.id || 0);

    const [, createRequestEmployeeResult] = useCreateRequestMutation({
        fixedCacheKey: CACHE_KEY_EMPLOYEE_CREATE_REQUEST,
    });

    const [, createRequestManagerResult] = useCreateRequestBeforePurchaseMutation({
        fixedCacheKey: CACHE_KEY_MANAGER_CREATE_REQUEST_BEFORE_PURCHASE,
    });

    const [, getOwnRequestsResult] = useRequestsListSharedQuery(ownRequestsParameters);

    const isLoading =
        createRequestEmployeeResult.isLoading ||
        createRequestManagerResult.isLoading ||
        getOwnRequestsResult.isFetching ||
        getOwnRequestsResult.isLoading;

    const handleSubmit = () => {
        const role = user?.role.code;
        if (role === UserRoles.Employee) {
            onCreateOrderEmployee();
        } else if (role === UserRoles.Manager) {
            onBuyProductManager();
        }
    };

    const handleOpenFeedback = () => {
        dispatch(setIsShowCreateFeedbackRequest(true));
    };

    const buyText = useMemo(() => {
        return buyProductText({
            hasManager: Boolean(currentOrganization.data?.manager),
            price: Number(product.price),
            productType: product.type.code,
            userRole: user?.role.code,
            withoutPrice: product.isPriceUndefined,
        });
    }, [user, currentOrganization]);

    return (
        <Wrapper>
            <Line>
                <Typography size='h6'>Стоимость</Typography>
                <PriceTag>
                    <Typography size='h4'>
                        {productPrice({ price: product.price, withoutPrice: product.isPriceUndefined })}
                    </Typography>
                    <RefundMoney size='s' />
                </PriceTag>
            </Line>
            <Divider />
            <Line>
                <Typography size='body1_long' color='neutral_50'>
                    Количество
                </Typography>
                <InputCount
                    withoutControls={product.type.code === ProductTypeCode.Demo}
                    value={productCounter}
                    min={1}
                    onChange={setProductCounter}
                />
            </Line>
            <Footer>
                <Button preloader={isLoading} disabled={isLoading} size='m' onClick={handleSubmit}>
                    {buyText}
                </Button>
                <SubmitDescriptionWrapper>
                    <SubmitDescription size='body2_long' align='center' as='p'>
                        Если у вас остались вопросы,{' '}
                        <Link size='sm' onClick={handleOpenFeedback}>
                            запросите консультацию
                        </Link>{' '}
                        у нашего специалиста
                    </SubmitDescription>
                </SubmitDescriptionWrapper>
            </Footer>
        </Wrapper>
    );
};
